import { useTranslation } from 'react-i18next'
import React from 'react'

import { useModalData } from '../../../../../components/modals/ModalsContext'
import { Col, Grid } from '../../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../../packages/kiti/components/presentation/Text'
import LineSeparator from '../../../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('webhook')
  const { id } = useModalData()

  const isEditing = id > 0

  const title = isEditing ? t('stays.editTitle') : t('stays.newTitle')

  return (
    <>
      <Grid justify="space-between" align="center">
        <Col flex={1}>
          <Title size="h5" bold>
            {title}
          </Title>
        </Col>
      </Grid>

      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
